import React, { useEffect, useState } from "react";
import {Box,Button,Flex,Image,Input,InputGroup,InputLeftElement,Text,} from "@chakra-ui/react";
import AddIcon from "../../../../assets/Images/Plus-icon.svg";
import { AddNewTeam, TeamManagementList } from "../components";
import { useFetch } from "../../../../hooks/useFetch";
import { CustomToast } from "../../../../components";
import useDebounce from "../../../../hooks/useDebounce";
import { Search2Icon } from "@chakra-ui/icons";
import CustomPagination from "../../../../components/CustomPagination";
import { Team } from "./modal";
import ServiceTeamManagementList from "../components/ServiceTeamManagementList";


const ServiceTeamManagement = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [teams, setTeams] = useState<Team[]>([]);
  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null);
  const { fetchApi, loading } = useFetch();
  const [searchQuery, setSearchQuery] = useState('');
  const { addToast } = CustomToast();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({ first: 0, rows: 10, page: 0, sortField: '', sortOrder: 1, });
  const pageCount = Math.ceil(totalCount / lazyParams.rows);
  const debounceSearch = useDebounce(searchQuery, 700);



  const handleEdit = (team: Team) => {
    setSelectedTeam(team);
    setIsOpen(true);
  };

  const handleSave =
    async () => {
      await getTeamList();
      setIsOpen(false);
      setSelectedTeam(null);
    };


  const getTeamList = async () => {
    const query = new URLSearchParams({
      lazyParams: JSON.stringify(lazyParams),
      search: debounceSearch,
    }).toString();
    const response = await fetchApi("ServiceTeamMast", "GET", null, query);
    if (response) { setTeams(response.teams || []); setTotalCount(response.totalcount || 0); }
  };


  useEffect(() => {
    getTeamList();
  }, [lazyParams, debounceSearch]);


  const handlePageClick = ({ selected }: { selected: number }) => {
    const updatedParams = {
      ...lazyParams,
      page: selected,
      first: selected * lazyParams.rows,
    };
    setLazyParams(updatedParams);
  };



  return (
    <>
      <Box p={6}>
        <Flex justify="space-between" align="center" mb={6}>
          <Text fontSize="24px" fontWeight="600">
           Service Team Management
          </Text>
          <Flex gap={4} align="center">
            <InputGroup width="197px" height="37px">
              <InputLeftElement pointerEvents="none">
                <Search2Icon color="rgba(102, 112, 133, 1)" />
              </InputLeftElement>
              <Input type="text" className='font-poppins text_regular text_md' placeholder="Search Team  Name...." maxW="400px" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </InputGroup>
            <Button
              leftIcon={<Image src={AddIcon} boxSize="14px" />} bg="#4F46E5" color="white" _hover={{ bg: "#4338CA" }} onClick={() => { 
                setSelectedTeam(null);
                setIsOpen(true);
              }}
            >Add Team </Button> </Flex> </Flex>

        <ServiceTeamManagementList teamData={teams} handleEdit={handleEdit} getTeamList={getTeamList} loading={loading} />

        <AddNewTeam isOpen={isOpen} onClose={() => { setIsOpen(false); setSelectedTeam(null); }} onSave={handleSave} selectedTeam={selectedTeam} 
        />
        <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={lazyParams.rows} rowsPerPageOptions={[10, 50, 100, 200]} setRowsPerPage={(value: number) => setLazyParams((prev) => ({ ...prev, rows: value, page: 0, first: 0 }))} totalRecords={totalCount} currentPage={lazyParams.page} />
      </Box>
    </>
  );
};

export default ServiceTeamManagement;